<template>
    <div
        class="conversation"
        :key="`conversation-${conversation.id}`"
        :data-conversation-id="conversation.id"
        :class="{
            'active': activeConversation && activeConversation.id === conversation.id,
            'archived': archived,
            'blocked': blocked,
        }"
        @click="onClick(conversation.id)"
        v-if="!archived && conversation.users.length === 2"
    >
        <span class="username">
            {{conversation.users.find(user => user.id !== currentUserId).username}}
        </span>
        <span
            class="unread"
            v-if="unreadMessages.length"
        >
            {{unreadMessages.length}}
        </span>
        <div class="conversation-menu-wrapper" @click="toggleConversationMenu">
            <fa-icon class="menu-icon" icon="ellipsis-vertical"></fa-icon>
            <div class="menu-options" v-if="showConversationMenu">
                <div class="menu-option" @click="onArchive(conversation.id)">
                    Hide conversation
                </div>
                <div class="menu-option" @click="onBlock(conversation.id)" v-if="onBlock">
                    Block user
                </div>
                <div class="menu-option" @click="onUnblock(conversation.id)" v-if="onUnblock">
                    Unblock user
                </div>
            </div>
        </div>
        <div
            class="conversation-menu-overlay"
            v-if="showConversationMenu"
            @click="toggleConversationMenu"
        >
        </div>
    </div>
</template>

<script>

export default {
    name: 'ConverastionCard',
    props: [
        'conversation',
        'activeConversation',
        'onClick',
        'onArchive',
        'onBlock',
        'onUnblock',
        'currentUserId',
        'blocked',
        'unreadMessages',
    ],
    data() {
        return {
            showConversationMenu: false,
        };
    },
    computed: {
        archived() {
            return this.conversation.users.find(user =>
                user.id === this.currentUserId,
            ).ConversationUserResource.archived;
        },
    },
    methods: {
        toggleConversationMenu(event) {
            event.stopPropagation();
            this.showConversationMenu = !this.showConversationMenu;
        },
    },
};
</script>

<style scoped lang="scss">
    @use "@/styles/styles.scss" as *;

    .conversation {
        background-color: white;
        border: 1px solid transparent;
        -webkit-transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
        transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
        border-radius: 4px;
        box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, .2),
            0px 1px 1px 0px rgba(0, 0, 0, .14),
            0px 1px 3px 0px rgba(0, 0, 0, .12);
        box-sizing: border-box;
        color: rgba(0, 0, 0, 0.87);
        display: flex;
        font-weight: normal;
        padding: 3px 3px 3px 7px;
        position: relative;
        text-align: left;
        user-select: none;
        width: 100%;

        > * {
            align-self: center;
        }

        .conversation-menu-wrapper {
            display: none;
        }

        &:hover {

            .conversation-menu-wrapper {
                display: inline-block;
            }
        }

        &:not(:first-of-type) {
            margin-top: 10px;
        }

        &:first-of-type {
            margin-top: 0;
        }

        &.active {
            border: 1px solid $teal;
        }

        &.archived {
            display: none;
        }

        &.blocked {
            background: $extra-light-gray;
        }

        &:hover {
            cursor: pointer;
        }

        .conversation-menu-wrapper {
            min-width: 15px;
            position: relative;
            text-align: center;

            .menu-options {
                background: white;
                border-radius: 4px;
                box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, .2),
                    0px 1px 1px 0px rgba(0, 0, 0, .14),
                    0px 1px 3px 0px rgba(0, 0, 0, .12);
                font-size: .75rem;
                padding: 4px 0;
                position: absolute;
                right: 0;
                top: 0;
                z-index: 201;

                .menu-option {
                    cursor: pointer;
                    padding: 4px 8px;
                    text-align: left;
                    white-space: nowrap;

                    &:hover {
                        background: $extra-light-gray-2;
                    }
                }
            }
        }

        .unread {
            background: $teal;
            border-radius: 50%;
            color: white;
            font-size: .7rem;
            min-width: 16px;
            min-height: 16px;
            text-align: center;
            vertical-align: middle;
            line-height: 16px;
        }

        .username {
            flex-grow: 1;
        }
    }

    .conversation-menu-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: transparent;
        z-index: 199;
    }

    @media only screen and (min-width: $screen-sm) {

    }

</style>
